import { CoreAddressesModel } from '@models/core-addresses.model';
import { PoolAddressesModel } from '@models/pool-addresses.model';
import { TokenInfo } from '@shared/constants/addresses/addresses.constant';

export const SONIC_BLAZE_TESTNET_CORE = new CoreAddressesModel(
  '0x65Dd6a2E14a5267a4bE6C117a57a8ECf0b640B68', // controller
  '0x185a1c105a0FedF0cc6e068eeE8eF01D6a399c39', // gameToken
  '0x271d8F8D7d48e17F0B47Dc510c279A84317094df', // minter
  '0xf9f1E7deE1DA7a35556feF8541E738feA799f4Ac', // goc
  '0xf8d288f008E10830b4fea56403c79DCd9AB613F5', // reinforcementController
  '0x32F0DB5796Aee07C350812130F2F39Fd2298E645', // dungeonFactory
  '0xDCD51970A13B077B87dCbF298aA88C4bB2aD6C04', // heroController
  '0x2ff1F61eDbA16a6a06f698F74f6Df06237fBEB4f', // itemController
  '0x0eFd93ea97464d585c6Cad77729809A64964Bf40', // oracle
  '0xF2f9E6324A94616cfb1b0E6C4eeAf9ce3B3F1f95', // statController
  '0xb7C36cB766230EB37F0d58efCA8Ed6379D1479A6', // storyController
  '0xF856586DEE0937672bfdB7B48F64DF83de2BFFc1', // treasury
  '0x450d08baC174FFf385262aace99fFbcB646CB852', // statReader
  '0xB88dD04593cBb35f3A550864C1de226E6BC74C2D', // multicall
  '0xcC0F338bD66D0CAC367a4c8d6Aac66DFf3e85524', // magicToken
  '0x185a1c105a0FedF0cc6e068eeE8eF01D6a399c39', // strengthToken
  '0x185a1c105a0FedF0cc6e068eeE8eF01D6a399c39', // dexterityToken

  '0xAa44d0C6bAEc36200DC2ea287aBB08E62De6C0e3', // pawnsop
  '0x2D44cd9E82734363aaFb9c3862ec828ac05bD585', // PawnShopRouterFactory
  '0x039e2fB66102314Ce7b64Ce5Ce3E5183bc94aD38', // network token
  '0xD106b67438d7743Ff32Bf70E5083282008c6F97a', // sponsored hero
  '0x42f1392e7E4D26047Ff81079BCABa1a5d30520aa', // relay
  '0x515b1C3A9EB87aeD820D5E7430F78dee4E055e2A', // data storage
  '0x38A64D285FF6f43e10D5Dc3162f0A5954F8341B3', // user controller
  '0x382C282f0620630bAac7929CF18606152Ee7f0AA', // item controller_helper
  '0x5150e4861eEA0e98A0771ea39E6B8b75eAC6FcFa', // guild controller
  '0xad9f3f5Ae77134dCB40B06E2C690c3EBB0894a6F', // shelterController
  '0x3b4b9C1cD013E2f8e9937b3Beac738B8831d8392', // shelterAuctionController
  '0x4F4435227Fd2c9C0Ca7a0Dc316d7F122b98F0226', // rewardsPool
  '0x21800cC81a4fA0e5198457dda3662646CEd2AB48', // pvp controller
  '0xe2Ff548664451ddBF53544A5b659dC637b0Aa7e9', // item box controller
  '0x432dfe55E314f5F7C944e759B401Be8e59dF83e8', // guildStakingManager
);

export const SONIC_BLAZE_TESTNET_TOKEN_INFO = new Map<string, TokenInfo>([
  [SONIC_BLAZE_TESTNET_CORE.gameToken.toLowerCase(), { symbol: 'SACRA', decimals: 18 }],
  [SONIC_BLAZE_TESTNET_CORE.magicToken.toLowerCase(), { symbol: 'USDC', decimals: 18 }],
  [SONIC_BLAZE_TESTNET_CORE.networkToken.toLowerCase(), { symbol: 'sFUEL', decimals: 18 }],
]);

export const SONIC_BLAZE_TESTNET_POOLS = new PoolAddressesModel('', '');

export const SONIC_BLAZE_TESTNET_DEX = {
  QUOTER_V2: '',
  SWAP_ROUTER_V2: '',
  NATIVE_USDC_POOL: '',
};

export function getSonicTestnetBlazeFaucetByToken(token: string) {
  if (SONIC_BLAZE_TESTNET_CORE.gameToken.toLowerCase() === token.toLowerCase()) {
    return '0x72f7e88a7BE819a721c4Df1F58CcDA2e8E63d875';
  } else if (SONIC_BLAZE_TESTNET_CORE.magicToken.toLowerCase() === token.toLowerCase()) {
    return '0xb18459069308989B21eD999f424c36b25D0fF2b8';
  } else {
    throw Error('No faucet for token ' + token);
  }
}

export const SONIC_BLAZE_TESTNET_ITEMS = {
  SACRA_CONS_1_ITEM: '0x3ff7e2dc9d5d9f5ea36537b256b73fea4825a53',
  SACRA_CONS_2_ITEM: '0xd8d85d1684998e9f312feebe988a86fd398ca3c',
  SACRA_CONS_3_ITEM: '0x3b60180fcb5b3e3d8f1c5d60510bd43107132298',
  SACRA_CONS_4_ITEM: '0x068f2f4f348d08e6ffa5cbcc63f57c83c3accb0f',
  SACRA_CONS_17_ITEM: '0xf661604f770aef8c56fc8c7a26840dcfbf30cec7',
  SACRA_CONS_18_ITEM: '0x2365aee368e5660afa255cec3b2d8ce383eb6fdf',
  SACRA_CONS_19_ITEM: '0x0ef630711d30c67be41d171d015e852c42f9bb19',
  SACRA_CONS_20_ITEM: '0x6859251e5cc9a9e5e0b54e22e8dffe01c93c7047',
  SACRA_CONS_21_ITEM: '0x4085973a08913d7bc02811f107c873d0724e66c8',
  SACRA_CONS_27_ITEM: '0x6afdbe83dbdd0cfc79285873863bc89c9536060a',
  SACRA_CONS_28_ITEM: '0x2fbf669925c79d96a75751a3f6b5dffc79de6c7f',
  SACRA_CONS_29_ITEM: '0x6f319569becea5df50d07327283e495475d5f701',
  SACRA_CONS_35_ITEM: '0x1cbb89d524c4f24e05c5df36e867c7728906aed0',
  SACRA_OTHER_1_ITEM: '0x4952f6512061423367fa88ff49fa687080407e1a',
  SACRA_OTHER_2_ITEM: '0xcea0cca5e553471538b4ffb16995fd004642c4c6',
  SACRA_OTHER_3_ITEM: '0x4a20b4dff5606545032824ff5b2f086d078a7ab8',
  SACRA_OTHER_4_ITEM: '0xbaf05e6035f9f77d113658d50b77e1b843e953c4',
  SACRA_OTHER_5_ITEM: '0x4ce6ccf4a588c3a82785e4bbeac7fe84290b46a5',
  SACRA_HELM_1_ITEM: '0x983986f1e6bc3f68ed6f617a56a3cecd191ae525',
  SACRA_HELM_6_ITEM: '0x570a10d34918ae3bebd8668a3ae2b6f3706e27d4',
  SACRA_HELM_9_ITEM: '0x72fbdf8741cc8d54ba9266fad53cb728b20d17f3',
  SACRA_BODY_1_ITEM: '0xb7d2c17632a801391ba17d0ab5c545e364850499',
  SACRA_GLOVES_1_ITEM: '0x9d26d54bca3f1767118095055587fbed63923515',
  SACRA_GLOVES_6_ITEM: '0xb0261de79a8ca336f5199e6c2adccc7df34e6997',
  SACRA_BELT_1_ITEM: '0x2d9a6a746fa43bd388a834e7bc6b0bcb651381cc',
  SACRA_BELT_5_ITEM: '0xecdc0ba6731d48579af118a33b2d97dcd8c57313',
  SACRA_AMULET_1_ITEM: '0xcadff82d69fa39a4d148ba28c4115ded13dbcb36',
  SACRA_AMULET_2_ITEM: '0xfa4fd7d9510224bca336faea507a4131a32f9e9d',
  SACRA_AMULET_12_ITEM: '0xa8d8316d4c986fcf01e19422190268c0f7dde98f',
  SACRA_AMULET_13_ITEM: '0x325ec42ec9dbbfe7e359d18644c8932a592d2a64',
  SACRA_RING_1_ITEM: '0x107855a427c2212c855dbd7711e3fb1a461a0cad',
  SACRA_RING_2_ITEM: '0xae1c6c2191afb62bcfb63f30f3d59896b5039c63',
  SACRA_RING_9_ITEM: '0x70e2fdb8afd79de3e93ae5e348c7d791b04ad2f4',
  SACRA_OFF_1_ITEM: '0x39c99db6423ca2e54f077bd96c99dcaea95c623f',
  SACRA_OFF_2_ITEM: '0xf6d1c5966104b072af65f7de8482c79efbeb92c7',
  SACRA_OFF_10_ITEM: '0x11501fd16f5fb3b74eedf65640a711b531c95115',
  SACRA_BOOTS_1_ITEM: '0xed851e99482a450755b9ce8df27b3adb6665c0a7',
  SACRA_BOOTS_5_ITEM: '0xba888614e540402eeae027c6bede8dced78a4bfd',
  SACRA_OHW_1_ITEM: '0x17c73a95b82a02508112760a72cd87182fbc8364',
  SACRA_OHW_2_ITEM: '0xdeddb780c7a672c49ba7b89646c2b599c7adee04',
  SACRA_OHW_3_ITEM: '0x39ae5a7db1a70154a102c5d5e7d3c8c970507671',
  SACRA_THW_1_ITEM: '0x1bc5bf72d6b655f22f57b1f62231983229819be5',
  SACRA_THW_2_ITEM: '0x9108f0ccab04d42c1a107f2d087e97c4e7aba71c',
  SACRA_FEAR_ITEM: '0x1b046c9f15492d0282f8260835ef3a01b127c7d5',
  SACRA_DEMON_SPEED_ITEM: '0xdd6379c76997b0d574f1225f6314b93bce1b17de',
  SACRA_BRUTE_FORCE_ITEM: '0xda83b7e8ed269b8221d00119d878fe414acd840e',
  SACRA_SAVAGE_CHARM_ITEM: '0xa1aa4eca9f004574bc04c3b0795f96376369d94a',
  SACRA_GOLDEN_EYE_ITEM: '0x041f31f5d6043efb7d2611eee7c426c6b331c478',
  SACRA_SABBAH_POISON_ITEM: '0x637817d1d4e25b9b8df57206ccbf0c303daac98e',
  SACRA_SPIT_IN_FACE_ITEM: '0x9fde0be49bfb5013b150bf25c879bb1a3a3b1e51',
  SACRA_ONSLAUGHT_ITEM: '0xef361263f83102f66dc1cc2789b844ed6368d662',
  SACRA_STRONG_BLOCK_ITEM: '0xe2293cac41c85fcd37955b51ff2d8816939063e0',
  SACRA_BEEF_PATTY_ITEM: '0x136d56320e0c792e2de176d1e35e8162fa18dce6',
  SACRA_HEAT_STRIKE_ITEM: '0x24f237327c650e05a60508bf50974db22d497f4c',
  SACRA_STATIC_DISCHARGE_ITEM: '0xce3c158c8428d37abcb340bc1cab390d88fac5d3',

  SACRA_CONS_5_ITEM: '0x07925bc8302f2374246b3b578b1b2e74dc630b4a',
  SACRA_CONS_6_ITEM: '0xd207a574fe2396c876150c25e3fc931eb72a2019',
  SACRA_CONS_7_ITEM: '0xdaed040a5bf2feddd2ab4959bfb853961e0d2760',
  SACRA_CONS_8_ITEM: '0x7fd10876f017cd0a607e9eea89895d539561c363',
  SACRA_CONS_22_ITEM: '0x6401b4942765d05d2cd6975c9de0c7b0db10dd36',
  SACRA_CONS_30_ITEM: '0x6552a9d7ed05da034063382eaff0cdfbb5984103',
  SACRA_HELM_2_ITEM: '0x8fbd3e1d2e01255145ed5c500c93055defcfe646',
  SACRA_HELM_7_ITEM: '0xa8d9bf9229961473c67083f516b2e4f224d7a38e',
  SACRA_BODY_2_ITEM: '0xc716333bfa07edb88cbc40789a6a9f3b71aa65a6',
  SACRA_BODY_6_ITEM: '0xbb1bdf7ba9e788e19a7d5e3ed80a6b196bd62bf1',
  SACRA_BODY_8_ITEM: '0x83e98c195886202f8051a9839edd71c65a8a9561',
  SACRA_GLOVES_2_ITEM: '0x1a0824cee53e6213d6057a60c8849dc52a775c4c',
  SACRA_GLOVES_7_ITEM: '0x2b2ca65f444fe6d1b98ac5c1224afd938e6fa726',
  SACRA_BELT_2_ITEM: '0xa61ac0caf3b2ff158b076c9f1eb6897bdb53bad2',
  SACRA_AMULET_3_ITEM: '0x9c07eae129fc9e956dba5aec30b301c1b723ccb6',
  SACRA_AMULET_4_ITEM: '0x0c41c58c272aad5b9dabdc3c18445be2a672fe46',
  SACRA_AMULET_9_ITEM: '0x83901eed705253b085e61994d1e91a05d09eaadc',
  SACRA_RING_3_ITEM: '0x8b38e6295498ee03ca49225e9526a5c9864fdddd',
  SACRA_RING_4_ITEM: '0x1df4d1b82fc0ef3ea055558b32a3c849de5fecbe',
  SACRA_RING_10_ITEM: '0x151f3bc32f1c06e6949444ab5056c404a166acc2',
  SACRA_RING_11_ITEM: '0xfd858cacb2ce0b071b4e60eacbfe68c9585c2c31',
  SACRA_OFF_3_ITEM: '0xfe48a085984876feed70b46049f08b92842c5d5a',
  SACRA_OFF_4_ITEM: '0x6c0315836df47120a375266c6f3a3864b34f044d',
  SACRA_OFF_11_ITEM: '0x2d290cf84caaedd1de4df0431e12b527ffc9253d',
  SACRA_BOOTS_2_ITEM: '0x344fd090c7d01d7f0bf7498e47d95cd8d904de0c',
  SACRA_OHW_4_ITEM: '0xe6de2d3a8088d79ff59f9c378b2574a7b4e17ddf',
  SACRA_OHW_5_ITEM: '0x8d56015ccf7d9c23aa0e9701cf4eaeed4603d08f',
  SACRA_OHW_6_ITEM: '0x4b763786e80c1cb610f64c4d214a9e81aede7b38',
  SACRA_THW_3_ITEM: '0x7d6c42e9013eaac121fe63137a55ba3ffd3d5bb9',
  SACRA_THW_4_ITEM: '0xb43514a98605b91e8a65f3a839f0109e1abd00da',
  SACRA_THW_5_ITEM: '0x2691809a06e411eb03e954167116ed3931a55509',
  SACRA_STEEL_SKIN_ITEM: '0x2131d52a4b84828352874981075022b87d93ba82',
  SACRA_LIFEDRAIN_ITEM: '0xacd570cc9e2c754c4fb861b7bf3400a9167eda6a',
  SACRA_FROSTBITE_ITEM: '0x5bd36a7a89c33b2ccb209d2506cee5fe86f879c8',
  SACRA_LIKE_A_PUSSY_ITEM: '0xab8e319249235ef7282fbdc00919fb6228e1359e',
  SACRA_RAGE_ITEM: '0x4ce6485d9e02ec12b21235378ae87987adcd85f0',
  SACRA_DEAD_STRIKE_ITEM: '0xbcedf0970264c26210b3498a9d1d2ca248083132',
  SACRA_FIRM_HAND_ITEM: '0xda90f3f9c3b509cdd10a9fa8fdc64062b32a0692',
  SACRA_JUSTICE_ITEM: '0x356c60b16f8f0857f95714602047415e992c7af4',
  SACRA_STEP_BACK_ITEM: '0x6660adbc4179a170b34b5f57d97879c5f9f05945',
  SACRA_PATIENCE_ITEM: '0xa74ea8fbf45c06d0de76b889166cdc8e3817e5a6',
  SACRA_TIME_AND_EXPERIENCE_ITEM: '0xe8d571925b96fbbda5596c067aea6904ba4e4431',
  SACRA_MELT_ITEM: '0xf2294990cba20d9b0a5ccecb3690bc1017be7ef7',
  SACRA_ICE_SHARD_ITEM: '0x3d31a9a45054ed909555262d8c9b78b5c268045d',

  SACRA_CONS_9_ITEM: '0x11068a2a24674f87076993bffbef56aed07fd5ac',
  SACRA_CONS_10_ITEM: '0xfbb13811cda2126f89bd0e7923c3441f213a7be9',
  SACRA_CONS_11_ITEM: '0xf5ded3708ef81762b34a6eeb6e1123989dd04e77',
  SACRA_CONS_12_ITEM: '0x886c1acbe1928715ff21c46181efc24bb55c2d01',
  SACRA_CONS_23_ITEM: '0x53a77ec8ec0410d0c321ea97d3963235afc9df14',
  SACRA_CONS_24_ITEM: '0x47cb1b5c1b106283785b8f96301b0b57c7e55faa',
  SACRA_CONS_31_ITEM: '0x9ccd17ef0783610358f570253eb1fc702409e43a',
  SACRA_HELM_3_ITEM: '0xe9de5b02c659506b9f235b81f870a88f5548dd03',
  SACRA_HELM_8_ITEM: '0x830a0a7256307934badadf313bff085aef7cb81f',
  SACRA_BODY_3_ITEM: '0xe9d166f3fb375d3e2e0de67ade54fcf8f4c8f272',
  SACRA_BODY_7_ITEM: '0xc6d62cdcf82dec146d26e80228008c41804efbba',
  SACRA_GLOVES_3_ITEM: '0x65cd76e387047b92e0be0bcd0dff622620cd1e24',
  SACRA_GLOVES_8_ITEM: '0x57db09a1bbb999ea0287ec7b04e90e1c0670ead3',
  SACRA_BELT_3_ITEM: '0xe08e92cfc97332827db54eb1de84a6608ea4cf21',
  SACRA_AMULET_5_ITEM: '0x270997b1805092aaeec2bcd91101b9e2009abf42',
  SACRA_AMULET_6_ITEM: '0x5243a14a623c5329609a2efd6013003151249a94',
  SACRA_AMULET_10_ITEM: '0x26d2db9560c085ff7b080217aeb24fecb34d3e6e',
  SACRA_AMULET_11_ITEM: '0x39532b4f8bc5b7fd008e3ef2e6a8817b528f649a',
  SACRA_RING_5_ITEM: '0x9db3970adf441792ae53cfe036e7b938a9a1c036',
  SACRA_RING_6_ITEM: '0xd244be21cd99b04de7383bf3a708b023d5274c3a',
  SACRA_OFF_5_ITEM: '0xc4d859aaf1cc0c3617b2be7e1afaede00fd7c594',
  SACRA_OFF_6_ITEM: '0xed7fdde579bc5d8ad6d9524237d0349b4f727b37',
  SACRA_BOOTS_3_ITEM: '0x2a33bc6465f7696dc3c6edde04863309984c6639',
  SACRA_BOOTS_6_ITEM: '0xf9549fa5ae73e5715c5aae5eeed4f613f6f2619f',
  SACRA_OHW_7_ITEM: '0x0c7025abaa3f0a21bed8ce6c2b651f818a01af06',
  SACRA_OHW_8_ITEM: '0xb488a17125c67f9576b14b307fbc0381313662f6',
  SACRA_OHW_9_ITEM: '0xe463956c5771c485d9eee68d31e6b9f738b2b618',
  SACRA_OHW_12_ITEM: '0x35a87328bfe7d44a13eba9dc156585fbbeb922c3',
  SACRA_OHW_13_ITEM: '0x19a5149bbfe44a6df8686392f6755f0352ca8c06',
  SACRA_OHW_14_ITEM: '0x5e39e760b67203eddc93ae18db2d5184e8004e73',
  SACRA_THW_6_ITEM: '0xaab7c54e6f25f90e4ea006e9e21d15c0d8a34db1',
  SACRA_THW_7_ITEM: '0x9575bb02550d67e44fcffd4ef34d3bfa97abbe6e',
  SACRA_THW_10_ITEM: '0xd9ab010e9dd47fcecd25a16c68e2cfd8c43b11ec',
  SACRA_PARALYZE_ITEM: '0x28b48c1a723f7b638974ed745a7d56d2f6e3a014',
  SACRA_GUIDING_LIGHT_ITEM: '0xc75747d27136a27731547aaea823242c2712fcea',
  SACRA_GUT_PUNCH_ITEM: '0xfcc8c60c316de86d2de2f1b3d7f248d16a5d302c',
  SACRA_LAST_DANCE_ITEM: '0x6fed6f2fb1e05354761979cc2e994e52566c982e',
  SACRA_I_SURVIVE_ITEM: '0x5d2805a91087c0b12a6b24dfd7229fc2b372271c',
  SACRA_ARMOR_OF_FAITH_ITEM: '0x6de8bc3ef5c73982c3f343550f435b738a5e814e',
  SACRA_THUNDERBOLT_ITEM: '0xeffc77693a45d5d7d6f44767a2bb5faab2883f9e',

  SACRA_CONS_13_ITEM: '0xec6400f498cd0feacd5bf1abdebad0375da03cd7',
  SACRA_CONS_14_ITEM: '0xe05aa2b4d5fd0cddfbe034013d6bebcb4631d8bb',
  SACRA_CONS_15_ITEM: '0x3d89c1f7e991744af3f6ee6cb9d3313ca7d4a506',
  SACRA_CONS_16_ITEM: '0xfc353ad36c052f610d1799bc7e11c37fa15e7ed2',
  SACRA_CONS_25_ITEM: '0x5d402dd3c9166cb2f91533452ecfd4cea60821db',
  SACRA_CONS_26_ITEM: '0x63327de5bad20c6674643099358d3a660026123b',
  SACRA_CONS_32_ITEM: '0x56076c35626f964e4d4e43a3ee8433aecf8c3dcf',
  SACRA_HELM_4_ITEM: '0xb7cd28c54a9847b306da6f6c44c66d657a5e45e5',
  SACRA_HELM_5_ITEM: '0x86f01dbe32a5fb5f34fd37b95928a159e52aed57',
  SACRA_BODY_4_ITEM: '0x1146bfe473f712f595440a35611511560a7be9dc',
  SACRA_BODY_5_ITEM: '0xd8d6a8cec2e494ddd8278bc780053981311a8cfd',
  SACRA_GLOVES_4_ITEM: '0x24ce4035a5622676b481ed6d1c521e3cbf3bc7cd',
  SACRA_GLOVES_5_ITEM: '0x35c6731d7e06e2a2f81276c21d92f46c148a02cb',
  SACRA_BELT_4_ITEM: '0x0ac4239dbe286f0c0190748037616b898030ebd2',
  SACRA_AMULET_7_ITEM: '0xb07ed8c9f854711bbb855f8b5e4471bb352f785b',
  SACRA_AMULET_8_ITEM: '0xcfe3a0185593873afbecaab61d47b44eb25c9330',
  SACRA_RING_7_ITEM: '0x9ed57127e55f0d782bf7361358a4242501483e63',
  SACRA_RING_8_ITEM: '0x83acd46d138dddc88d5a8875af869dc7b6f05773',
  SACRA_OFF_7_ITEM: '0xa7ab49da3b702d146133f15b86d070bd262ed937',
  SACRA_OFF_8_ITEM: '0xc0d52329b8d0fde575afc39392996b7dd5e1573a',
  SACRA_OFF_9_ITEM: '0x99e214ced47f14647bc25c22e2ce3c8ac0ccbb7d',
  SACRA_OFF_12_ITEM: '0x08ea531ff1e8bac12e9894d866a934ee12c38d4c',
  SACRA_OFF_13_ITEM: '0xc513c40b0c7f917b4bb4b5c7e2cace6674c8a705',
  SACRA_BOOTS_4_ITEM: '0xbbfaa5edfefd0fdb9e6a6aeaffd1780766e1c4d8',
  SACRA_BOOTS_7_ITEM: '0x1a0e41e8403da8011e6ec149a9268bd486c4cf04',
  SACRA_OHW_10_ITEM: '0x968d4aa7e007679e0aac8dc2cac4735e9843232a',
  SACRA_OHW_11_ITEM: '0x44aa84fa4d0c177d6a5f0de0da9b69056c577175',
  SACRA_THW_8_ITEM: '0xf0b3f7a5205f8bf8438c95ace70d21f3814efb20',
  SACRA_THW_9_ITEM: '0xcff2b431799e7d9c787de3869389f70ef6da79cc',
  SACRA_THW_11_ITEM: '0x84bb8011d59d89cf7e9e670591e51a0f55f41115',
  SACRA_REFLECTION_ITEM: '0x73a4ab63679f1daf2f79ba2e17fdaad026833416',
  SACRA_SCARLET_BRANCH_ADEPT_ITEM: '0x3c4b851bcebf35f6e786b8a478b145205dd47266',
  SACRA_ANATHEMA_ITEM: '0x1f4a0af46edee46cc4ec58cf424808ce19180a77',
  SACRA_GIANTS_BLOOD_ITEM: '0xe53a8d660dbb9819ffd40825d4930d5279a8328d',
  SACRA_BACKSTAB_ITEM: '0x3cc1117d0da14c363ee606f6a3beaec088285665',
  SACRA_VETERAN_CONFIDENCE_ITEM: '0x795388c3bbb595ae5add71c2ce8089fe1478eed7',
  SACRA_LIVE_FORTRESS_ITEM: '0x9ad380c1824ff9f36ef15fcb7947391ac4253754',
  SACRA_COLD_SHOULDER_ITEM: '0x34c2a9d93b0e2d524b5e5d495794ccac32f39fcf',
  SACRA_ERASE_ITEM: '0xe1a0c39d6a501b23c9fac27a27352343250f7654',

  SACRA_CONS_34_ITEM: '0x1e7b1ae05c9caabe02c129f757158a2f96d2e6a0',
  SACRA_CONS_36_ITEM: '0x160f7a446f5a4042e2a0397623dd57a7b13961af',
  SACRA_CONS_37_ITEM: '0xcaac86ad3138348ffbcc67e0826866ce1613c7dc',
  SACRA_CONS_38_ITEM: '0xe0a54124655ae3de404c24d6cb4203935b97710e',
  SACRA_CONS_39_ITEM: '0x5b9b2a259ddb5414e299d9fadd049a8a568ca9a1',
  SACRA_CONS_40_ITEM: '0xb456bbacfdc55518210a4d7d495c804762ba22c1',
  SACRA_CONS_41_ITEM: '0x58620f6ac9d2967a388af7d89230e1f51bf1421b',
  SACRA_CONS_43_ITEM: '0x17e4f66ee8cde4384f407c23a3a83f6aaf8b7d8d',
  SACRA_HELM_10_ITEM: '0x83077ef7ee5953cfacdcc615add32d8fe023b5db',
  SACRA_HELM_11_ITEM: '0xc9429c95273463a446917117f85f30ca4f98c24b',
  SACRA_BODY_9_ITEM: '0x25ae5712e195b63d85102d4111d90c9a2b75fa6b',
  SACRA_BODY_10_ITEM: '0x410111ead621f514816c65d88f284b3918c5386f',
  SACRA_BODY_11_ITEM: '0xf50ca89f400c5b731307f7bd02023967bb4cf7f4',
  SACRA_GLOVES_9_ITEM: '0xa63508e995cff86dcf9bb13575048c7a8f72adbb',
  SACRA_GLOVES_10_ITEM: '0x2d62fc0b23c632e110526978bea9b0a5309371b2',
  SACRA_GLOVES_11_ITEM: '0x8e1bde802d1ac8f63ca22b9addbb2160651d81b7',
  SACRA_BELT_6_ITEM: '0x71d9b99640f8a6b3e9e1c76d04b7c3203cee87c0',
  SACRA_BELT_7_ITEM: '0x6548ad09d83b7ef1e0edaa7eee12bb4e55fd922b',
  SACRA_AMULET_14_ITEM: '0x5e7b76b3c9cde2c74f381d1c4c9d647b3696b7c8',
  SACRA_AMULET_15_ITEM: '0x108faa88766235a903a01cb8344e8ba490b5f60d',
  SACRA_AMULET_16_ITEM: '0x54c9bd7104660264b7f0fc99a521b92ebb86dc4f',
  SACRA_AMULET_17_ITEM: '0xcf5d6c6e8c8175b995e5d551c67c694c78f5b4de',
  SACRA_RING_12_ITEM: '0x508fe5f05a05a782a77fc065d49ba598f15271a2',
  SACRA_RING_13_ITEM: '0x6689204b40fad2923b683f46c06a4002f1f2333a',
  SACRA_RING_14_ITEM: '0x3cd9fede8bf718f2a3753c474a8458edc78365bc',
  SACRA_OFF_14_ITEM: '0xd0656f058d4ef27a740d72adbf4d5c2887148a94',
  SACRA_OFF_15_ITEM: '0x2e1214a83f1e37b47e3090ee9d94e3bf15e2d0b2',
  SACRA_OFF_16_ITEM: '0x0340312aa7534ba2762a0522b2a128ec1c83989e',
  SACRA_BOOTS_8_ITEM: '0x46da14ddc0eaf90dd5be91bd4d0bf57ead3ff9ef',
  SACRA_BOOTS_9_ITEM: '0x4cb480258a392c3b089591d9c045cee21a7aa654',
  SACRA_BOOTS_10_ITEM: '0x48b8f08c1bf8bdc904fb0b0f8dfe2cd423907fca',
  SACRA_BOOTS_11_ITEM: '0x66b69547df3f47ac7d32a7c48256e7f9893f0283',
  SACRA_OHW_15_ITEM: '0x5f87ad1df1795ac601a460a6aa8d9102fa1df647',
  SACRA_OHW_16_ITEM: '0xd1bf0c84b03bc5ced3800b0d7774fb4099a1e015',
  SACRA_OHW_17_ITEM: '0x3e4f16124c6c89ddd6558a02ed333d9c578967d2',
  SACRA_OHW_18_ITEM: '0xc376e1087a1d8d9aa831c3f22d7b29e15a582147',
  SACRA_OHW_19_ITEM: '0x3ee6f812ca127c525bab68a09cb54976c9c4ff16',
  SACRA_THW_12_ITEM: '0x8f490bea60bacbd7739f803f983aa6420d45fa61',
  SACRA_THW_13_ITEM: '0x6c4d81a121547c3b8fadadffe5791e6d2495383d',
  SACRA_THW_14_ITEM: '0xc68fc3b45014e5be589af1e4f90f3c05f2071916',
  SACRA_THW_16_ITEM: '0xbd572162c7ebce1b664a6acc418ebac160c4d911',
  SACRA_HEAD_OFF_ITEM: '0x50bac72bacb8aadfb55d7ac3d3b32e7fbc1919d7',
  SACRA_VOICE_OF_DEAD_GOD_ITEM: '0x23ffbc536046ac36d9a4dd0848b8835b23149df3',
  SACRA_FAST_ROLL_ITEM: '0x03274b6f1b139907eee63b40b896110fb03a7b4e',
  SACRA_MEATGRINDER_ITEM: '0xbef70d1803c995baa2d7812e7557e714a1a25370',
  SACRA_DEMOLDERS_TOUGHNESS_ITEM: '0x41165b9e0846b8df27d21ee5078ac8e3d94be5a1',
  SACRA_PYROMANIAC_ITEM: '0x745d6d8341efa263f8d022f706381a1e56cb4481',
  SACRA_BLAST_ITEM: '0x81f93cec4eb06eaf008c9adf1f2c56a59169fbc7',
  SACRA_HORSEBREAKER_ITEM: '0xcd7a46f611e4919f57f7a304c54cb4eb71cbde23',
  SACRA_FIRE_POT_ITEM: '0xc9c749b1af67e6620d1b54e3ba23fab357f27126',
};
